export default __webpack_public_path__ + "static/media/filterIcon.d6343895.svg";